import { render, staticRenderFns } from "./ListagemEstoque.vue?vue&type=template&id=8855ceb0&"
import script from "./ListagemEstoque.vue?vue&type=script&lang=js&"
export * from "./ListagemEstoque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports